import { Button, IconButton } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import AttachmentIcon from "@mui/icons-material/Attachment";
import DeleteIcon from "@mui/icons-material/Delete";
import PropTypes from "prop-types";
import "./FileUploader.css";
import { toast } from "react-toastify";
/*istanbul ignore next */
const FileUploader = React.forwardRef((props, ref) => {
  const {
    accept,
    onSelectFile,
    sourceFile,
    onDeleteFile,
    maxSizeInBytes,
    maxSizeExeedError,
    disabled,
    deleteDisable,
    selectLabel,
  } = props;
  const hiddenFileInput = useRef(null);
  const [file, setFile] = useState(null);

  useEffect(() => {
    setFile(sourceFile);
  }, [sourceFile]);

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleChange = (event) => {
    const selectedFile = event.target.files[0];
    const fileSize = selectedFile?.size;

    if (fileSize > maxSizeInBytes) {
      toast.error(maxSizeExeedError);
      return;
    }
    onSelectFile(event);
  };

  const onDeleteFileHandler = () => {
    hiddenFileInput.current.value = null;
    onDeleteFile();
  };

  /* Expose file input to parent via ref so it can be reset */
  React.useImperativeHandle(ref, () => hiddenFileInput.current, []);

  return (
    <div className={disabled ? "disable-file-uploader" : "file-uploader"}>
      <div className={`file-div ${disabled && "disabled"}`}>
        <Button
          className="attachment-icon"
          onClick={handleClick}
          disabled={disabled}
        >
          <AttachmentIcon />
          <input
            type="file"
            id="actual-btn"
            accept={accept}
            ref={hiddenFileInput}
            onChange={handleChange}
            hidden
            disabled={disabled}
            data-testid="file-upload-input"
          />
          <div className="file-name">
            {file ? (
              <div className="selected-file">{file?.name}</div>
            ) : (
              <div>{selectLabel || "Select File"}</div>
            )}
          </div>
        </Button>
      </div>
      <div className={`${disabled && "disabled"}`}>
        <IconButton
          aria-label="delete"
          disabled={disabled || deleteDisable}
          color="primary"
          onClick={onDeleteFileHandler}
        >
          <DeleteIcon />
        </IconButton>
      </div>
    </div>
  );
});

FileUploader.displayName = "FileUploader";

/* ✅ Add complete PropTypes validation */
FileUploader.propTypes = {
  accept: PropTypes.string,
  onSelectFile: PropTypes.func.isRequired,
  sourceFile: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onDeleteFile: PropTypes.func.isRequired,
  maxSizeInBytes: PropTypes.number,
  maxSizeExeedError: PropTypes.string,
  disabled: PropTypes.bool,
  deleteDisable: PropTypes.bool,
  selectLabel: PropTypes.string,
};

export default FileUploader;
